module.exports = __webpack_public_path__ + "static/media/bar-icon.39ecc3b9.svg";